import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import _ from "lodash";
import { Segment, Accordion, Icon, Button } from "semantic-ui-react";

import { useAuth0 } from "../../../auth/auth0";
import { useModuleNavigation } from "../../../hooks/useModuleNavigation";

const Support = ({ origin = "", updateSections = "" }) => {
	const { isAuthenticated } = useAuth0();
	const moduleNavigation = useModuleNavigation();

	const [activeIndex, setActiveIndex] = useState(null);
	const [hiddenSections, setHiddenSections] = useState([]);

	useEffect(() => {
		let keywords = _.filter(updateSections.split(" "), (s) => s !== "");
		let hide = [];

		if (keywords.length > 0) {
			let sections = ["viewers", "landing", "annotations", "trial-analyses", "protocol-analyses"];

			_.forEach(sections, (section) => {
				let text = getText(document.getElementById(section));

				if (!_.some(keywords, (k) => text.toUpperCase().includes(k.toUpperCase()))) {
					hide = [...hide, section];
				}
			});
		}

		setHiddenSections(hide);
	}, [updateSections]);

	const getText = (element) => {
		return worker(element);

		function worker(node, text = "") {
			if (node.nodeType === Node.TEXT_NODE) {
				text += `${node.nodeValue} `;
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				for (const child of node.childNodes) {
					text = worker(child, text);
				}
			}
			return text;
		}
	};

	const handleClick = (e, titleProps) => {
		const { index } = titleProps;
		const newIndex = activeIndex === index ? -1 : index;
		setActiveIndex(newIndex);
	};

	return (
		<Segment style={{ margin: origin === "modal" ? "unset" : 15 }}>
			<script src="https://player.vimeo.com/api/player.js"></script>
			{/* <u><p>
				If you have any questions that cannot be answered by the FAQs below or require assistance, please contact
				aerialPLOT support at <a href="mailto:support@aerialplot.com">support@aerialplot.com</a>
			</p></u>

			<Accordion>
				<Accordion.Title
					active={activeIndex === 0}
					index={0}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					How do I reset my password?
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 0}>
					<u><p>
						aerialPLOT uses Microsoft and Google authentication to allow users to log into the system. We do not store
						passwords. If you have forgotten your password, please refer to these articles.
					</p></u>
					<ul>
						<li>
							<a
								href="https://support.microsoft.com/en-us/help/4026971/microsoft-account-how-to-reset-your-password"
								rel="noopener noreferrer"
								target="_blank"
							>
								How to reset your Microsoft account password
							</a>
						</li>
						<li>
							<a
								href="https://support.microsoft.com/en-us/help/17875/microsoft-account-reset-or-recover-password"
								rel="noopener noreferrer"
								target="_blank"
							>
								Reset or recover your Microsoft account
							</a>
						</li>
						<li>
							<a
								href="https://support.google.com/accounts/answer/41078?co=GENIE.Platform%3DDesktop&hl=en"
								rel="noopener noreferrer"
								target="_blank"
							>
								How to reset your Google account password
							</a>
						</li>
						<li>
							<a
								href="https://accounts.google.com/signin/v2/recoveryidentifier?flowName=GlifWebSignIn&flowEntry=ServiceLogin"
								rel="noopener noreferrer"
								target="_blank"
							>
								Reset or recover your Google account
							</a>
						</li>
					</ul>
					<u><p>
						{`If you're using an account issued to you by your work, school, or organization, please contact your IT helpdesk.`}
					</p></u>
				</Accordion.Content>
			</Accordion> */}

			<Accordion style={{ paddingTop: "4px" }} hidden={hiddenSections.includes("viewers")} id="viewers">
				<Accordion.Title
					active={activeIndex === 1}
					index={1}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Viewers
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 1}>
					<u>
						<p>Viewer and Map Controls</p>
					</u>
					<ul>
						<li>Viewer Overview and Timeline Controls</li>
						<li>Map Controls </li>
						<li>Map Shortcuts</li>
						<li>Adjust Images</li>
						<li>Overlays and Labels </li>
						<li>Flags and Exclusions </li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074043811?h=5c356e4728&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Viewer and Map Controls"
						></iframe>
					</div>
					<br />
					<u>
						<p>Farm Viewer</p>
					</u>
					<ul>
						<li>Field, Crop Type and Trial Selection </li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074016218?h=ea9f52f835&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Farm Viewer"
						></iframe>
					</div>
				</Accordion.Content>
			</Accordion>

			<Accordion style={{ paddingTop: "4px" }} hidden={hiddenSections.includes("landing")} id="landing">
				<Accordion.Title
					active={activeIndex === 2}
					index={2}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Landing Pages and Misc.
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 2}>
					<u>
						<p>Home Page</p>
					</u>
					<ul>
						<li>Navigation and Subnav icons </li>
						<li>Protocol and Trial Selection</li>
						<li>Protocol and Trial Quick Tables </li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074016253?h=b60568926a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Home Page"
						></iframe>
					</div>
				</Accordion.Content>
			</Accordion>

			{/* <Accordion style={{ paddingTop: "4px" }}>
				<Accordion.Title
					active={activeIndex === 3}
					index={3}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Flights
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 3}>
					<u><p>Video Highlights:</p></u>
					<ul>
						<li>Create a new Flight (RGB): Field and Align</li>
						<li>Create a new Flight (Multispectral): Field, Align, Analyze</li>
						<li>Edit an Existing Flight: Making Alignment Changes</li>
					</ul>
				</Accordion.Content>
			</Accordion> */}

			{/* <Accordion style={{ paddingTop: "4px" }}>
				<Accordion.Title
					active={activeIndex === 4}
					index={4}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Farms
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 4}>
					<u><p>Video Highlights:</p></u>
					<ul>
						<li>Creating a New Farm: Walkthrough to Summary</li>
						<li>Editing an Existing Farm</li>
					</ul>
				</Accordion.Content>
			</Accordion> */}

			{/* <Accordion style={{ paddingTop: "4px" }}>
				<Accordion.Title
					active={activeIndex === 5}
					index={5}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Fields
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 5}>
					<u><p>Video Highlights:</p></u>
					<ul>
						<li>Adding a New Field</li>
						<li>Understanding Fields Sub-Navigation Tabs </li>
						<li>Ground Data Set Creation & Upload (Field Level)</li>
						<li>Creating a New Trial & Editing Trial Information/Layout </li>
						<li>Data Export Modal: How It Works</li>
						<li>Editing Field Info & Advanced Analytics (Adding QRs & Analysis in Flights) </li>
					</ul>
				</Accordion.Content>
			</Accordion> */}

			<Accordion style={{ paddingTop: "4px" }} hidden={hiddenSections.includes("annotations")} id="annotations">
				<Accordion.Title
					active={activeIndex === 6}
					index={6}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Meta-Tags & Annotations
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 6}>
					<u>
						<p>Meta-Tags & Annotations</p>
					</u>
					<ul>
						{/* <li>Making Changes to an Existing Trial (Trial Wizard)</li>
						<li>Trial Publishing: How to Publish & Unpublish Data </li>
						<li>Ground Data Set Creation & Upload (Trial Level) </li> */}
						<li>Whole Trial Annotations </li>
						{/* <li>Trial Weather Functionality </li> */}
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1076183826?h=4a4a17dcb0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Meta-Tags and Annotations Modal"
						></iframe>
					</div>
				</Accordion.Content>
			</Accordion>

			<Accordion style={{ paddingTop: "4px" }} hidden={hiddenSections.includes("trial-analyses")} id="trial-analyses">
				<Accordion.Title
					active={activeIndex === 7}
					index={7}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Trial Analysis
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 7}>
					<u>
						<p>Trial Analysis Module</p>
					</u>
					<ul>
						<li>Overview </li>
						<li>Filtering </li>
						<li>Timecourse Data Table </li>
						<li>Data Visualization </li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074016331?h=743d22ef34&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Trial Analysis Module"
						></iframe>
					</div>
					<br />
					<u>
						<p>Summary Table Module</p>
					</u>
					<ul>
						<li>Summary Table Overview and Presets</li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074016315?h=78698c6820&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Summary Table Module"
						></iframe>
					</div>
					<br />
					<u>
						<p>Box Whisker Module</p>
					</u>
					<ul>
						<li>Box Whisker Overview and Filtering</li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1074016209?h=c6cc10d474&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Box Whisker Module"
						></iframe>
					</div>
				</Accordion.Content>
			</Accordion>

			{/* <Accordion style={{ paddingTop: "4px" }}>
				<Accordion.Title
					active={activeIndex === 8}
					index={8}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Trial Curve Models
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 8}>
					<u><p>Video Highlights:</p></u>
					<ul>
						<li>Landing Page Table Overview</li>
						<li>Growth, Senescence, and Full Season Tabs</li>
					</ul>
				</Accordion.Content>
			</Accordion> */}

			{/* <Accordion style={{ paddingTop: "4px" }}>
				<Accordion.Title
					active={activeIndex === 9}
					index={9}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Protocols
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 9}>
					<u><p>Video Highlights:</p></u>
					<ul>
						<li>Creating a New Protocol: Step by Step </li>
						<li>Editing an Existing Protocol (All Tabs)</li>
						<li>Ground Dataset Creation & Editing for Protocols </li>
						<li>Data Export Functionality for Protocols</li>
					</ul>
				</Accordion.Content>
			</Accordion> */}

			<Accordion
				style={{ paddingTop: "4px" }}
				hidden={hiddenSections.includes("protocol-analyses")}
				id="protocol-analyses"
			>
				<Accordion.Title
					active={activeIndex === 10}
					index={10}
					onClick={handleClick}
					style={{ backgroundColor: "#EEEEEE", borderRadius: "4px" }}
				>
					<Icon name="dropdown" />
					Protocol Analysis
				</Accordion.Title>
				<Accordion.Content active={activeIndex === 10}>
					<u>
						<p>Protocol Analysis</p>
					</u>
					<ul>
						<li>Module Overview</li>
						{/* <li>Protocol Box Whisker: How to Use It </li> */}
						<li>Filtering</li>
						{/* <li>Protocol Piano Charts: Visualizing Trends</li> */}
						<li>Compiled Protocol Data</li>
						<li>Trial Data Control</li>
						<li>Trial Growth Curves</li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1076795202?h=a666c662d1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Protocol Analysis"
						></iframe>
					</div>
					<br />
					<u>
						<p>Protocol Summary Table</p>
					</u>
					<ul>
						<li>Treatment Data Table and Filters </li>
						<li>Site-Specific Data Table and Filters </li>
					</ul>
					<div style={{ padding: "17.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/1076795219?h=aef9730fb9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
							frameBorder="0"
							allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
							style={{ position: "absolute", top: 0, left: 0, width: "35%", height: "100%" }}
							title="aerialFARMS - Protocol Summary Table"
						></iframe>
					</div>
				</Accordion.Content>
			</Accordion>

			{!isAuthenticated && (
				<Segment basic textAlign="center">
					<Button
						content="Return to Login"
						onClick={() => {
							moduleNavigation.goToLogin();
						}}
					/>
				</Segment>
			)}
		</Segment>
	);
};

Support.propTypes = {
	origin: PropTypes.string,
	updateSections: PropTypes.string,
};

export default Support;
